import { render, staticRenderFns } from "./others.vue?vue&type=template&id=5581061e&scoped=true&"
import script from "./others.vue?vue&type=script&lang=js&"
export * from "./others.vue?vue&type=script&lang=js&"
import style1 from "./others.vue?vue&type=style&index=1&id=5581061e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5581061e",
  null
  
)

export default component.exports